import React from 'react'
import { useTranslation } from 'react-i18next'

import { useWidgetState } from '../../WidgetWrapper'
import Dropdown from '../../../../../packages/kiti/components/navigation/Dropdown'

const EntityDropdown = () => {
  const { t } = useTranslation('common')
  const {
    value,
    actions: { handleChange }
  } = useWidgetState()

  const OPTIONS = [
    { id: 'checklist', name: t('widgets.questionnaire') },
    { id: 'place', name: t('widgets.locals') },
    { id: 'user', name: t('widgets.user') }
  ]

  const name = value?.entity?.name || t('widgets.questionnaire')

  return (
    <Dropdown
      label={`${t('widgets.groupedBy')} ${name}`}
      onChange={handleChange('entity')}
      options={OPTIONS}
      placement="bottomRight"
    />
  )
}

export default EntityDropdown
